import { css } from '@lyearn/style';

export const logoStyle = css`
  img {
    object-fit: contain;
  }
`;
